import React, { useEffect, useState } from 'react';
import Pagination from '../../components/Pagination';
import LoadingOverlay from '../../components/Static/LoadingOverlay';
import { Log } from '../../models/model';
import { LogGetPaging } from '../../services/logService';
import { toast } from 'react-hot-toast';
import { fetchLicenseClasses } from '../../store/licenseSlice';
import moment from 'moment-timezone';
import CustomDatePicker from '../../components/DatePickerVi';
import { aC } from '@fullcalendar/core/internal-common';

export default function Auditlog() {
	const [action, setAction] = useState(null);
	const [pagination, setPagination] = useState({
		pageIndex: 1,
		pageSize: 10,
		totalRecords: 0,
		totalPages: 1,
	});
	const [isLoading, setIsLoading] = useState(true);
	const [logs, setLogs] = useState<Log[]>([]);
	const [searchText, setSearchText] = useState<string>('');
	const [startDate, setStartDate] = useState<Date | null>();
	const [endDate, setEndDate] = useState<Date | null>(null);
	const handlePageChange = (newPageIndex: number) => {
		if (newPageIndex < 1 || newPageIndex > pagination.totalPages) return;
		fetchLogs(newPageIndex);
	};
	const fetchLogs = async (
		pageIndex: number,
		keepPageIndex: boolean = false
	) => {
		setIsLoading(true);
		try {
			const res = await LogGetPaging({
				pageIndex: keepPageIndex ? pagination.pageIndex : pageIndex,
				pageSize: pagination.pageSize,
				freeTextSearch: searchText,
				action: action ? Number.parseInt(action) : null,
				startDate: startDate ? startDate.toISOString() : null,
				recordId: null,
				endDate: endDate ? endDate.toISOString() : null,
			});
			setLogs(res.result.items);
			setPagination((prev) => ({
				...prev,
				pageIndex: keepPageIndex ? prev.pageIndex : pageIndex,
				totalRecords: res.result.totalRecord,
				totalPages: Math.ceil(
					res.result.totalRecord / pagination.pageSize
				),
			}));
			console.log(logs);
		} catch (error) {
			toast.error('Lỗi khi lấy nhật ký: ' + error.message);
		} finally {
			setIsLoading(false);
		}
	};
	const handleDateChange = (type: 'start' | 'end') => (date: Date | null) => {
		if (type === 'start') {
			setStartDate(date);
			// If new start date > current end date, reset end date
			if (date && endDate && date > endDate) {
				setEndDate(null);
			}
		} else {
			setEndDate(date);
		}
	};

	useEffect(() => {
		fetchLogs(1);
	}, []);

	const handleSearch = () => {
		// Reset to first page when searching
		fetchLogs(1);
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSearch();
		}
	};
	return (
		<div>
			<div className='mx-auto'>
				<div className='grid grid-cols-1 gap-8'>
					<div className='bg-white rounded-lg shadow-md p-4 md:p-6'>
						<h1 className='text-2xl md:text-3xl font-bold text-gray-800 mb-4'>
							Nhật ký hệ thống
						</h1>
						{/* Header controls */}
						<div className='mb-6'>
							<div className='md:flex items-end gap-3'>
								<div className='flex-1 grid grid-cols-1 md:grid-cols-4 gap-3 '>
									<div className='space-x-1'>
										<label className='text-xs text-gray-500 block'>
											Từ ngày
										</label>
										<CustomDatePicker
											// @ts-ignore
											selected={startDate}
											onChange={handleDateChange('start')}
											placeholder='Từ'
											id='startDate'
											name='startDate'
										/>
									</div>
									<div className='space-x-1'>
										<label className='text-xs text-gray-500 block'>
											Đến ngày
										</label>
										<CustomDatePicker
											// @ts-ignore
											selected={endDate}
											onChange={handleDateChange('end')}
											placeholder='Đến'
											id='endDate'
											name='endDate'
											className='h-[38px]'
										/>
									</div>
									<div className='space-x-1'>
										<label className='text-xs text-gray-500 block'>
											Trạng thái
										</label>
										<select
											className='md:min-w-max w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none'
											value={action}
											onChange={(e) =>
												setAction(e.target.value)
											}>
											<option value=''>Tất cả</option>
											<option value='0'>Tạo</option>
											<option value='1'>Cập nhật</option>
											<option value='3'>Nhập dữ liệu</option>
											<option value='4'>Xuất dữ liệu</option>
											<option value='2'>Xóa</option>
										</select>
									</div>
									<div className='space-x-1'>
										<label className='text-xs text-gray-500 block'>
											Tìm kiếm
										</label>
										<div className='flex gap-2'>
											<input
												type='text'
												placeholder='Tìm khóa...'
												value={searchText}
												onChange={(e) =>
													setSearchText(
														e.target.value
													)
												}
												onKeyDown={handleKeyDown}
												className='w-100 px-4 py-2 border border-gray-300 rounded-md focus:outline-none'
											/>
											<button
												onClick={handleSearch}
												className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 '>
												Tìm
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* Table */}
						<div className='w-full overflow-x-auto'>
							<table className='min-w-max w-full divide-y divide-gray-200'>
								<thead className='bg-gray-50'>
									<tr>
										<th className='px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider'>
											Nhật ký
										</th>
										<th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
											Thao tác
										</th>
										<th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
											Thời gian
										</th>
										<th className='px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
											Thực hiện bởi
										</th>
									</tr>
								</thead>
								<tbody className='bg-white divide-y divide-gray-200'>
									{logs.map((row, idx) => (
										<tr
											key={idx}
											className={`border-t hover:bg-gray-50 transition`}>
											<td className='p-3'>
												{row.detail}
											</td>
											<td className='p-3'>
												<span
													className={`badge badge-pill ${
														row.action == 'Create' || row.action == 'Import' || row.action == 'Export'
															? 'badge-success'
															: row.action ==
															  'Update'
															? 'badge-warning'
															: 'badge-danger'
													}`}>
													{row.action}
												</span>
											</td>
											<td className='p-3'>
												{moment(
													row.creationDate
												).format('DD/MM/YYYY HH:mm:ss')}
											</td>
											{/*<td className='p-3'>*/}
											{/*	<span*/}
											{/*		className={`px-2 py-1 text-sm rounded-lg font-medium ${*/}
											{/*			row.action === 'Active'*/}
											{/*				? 'bg-green-100 text-green-700'*/}
											{/*				: 'bg-red-100 text-red-700'*/}
											{/*		}`}>*/}
											{/*		{row.action}*/}
											{/*	</span>*/}
											{/*</td>*/}
											<td className='p-3'>
												{row.fullName}
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
						{/* Pagination */}
						<Pagination
							pagination={pagination}
							isLoading={isLoading}
							onPageChange={handlePageChange}
							label='khóa học'
						/>

						{isLoading && (
							<LoadingOverlay message='Đang tải dữ liệu...' />
						)}

						{!isLoading && logs.length === 0 && (
							<div className='mt-4 text-center text-gray-500'>
								Chưa có nhật ký!
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
